import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-role_production_gou",
  "use": "icon-role_production_gou-usage",
  "viewBox": "0 0 239.8 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 239.8 200\" id=\"icon-role_production_gou\">\r\n<path d=\"M84.2,125.1l-58.3-44L0,101.1L100.7,200C117.9,157.1,173,73,240,13.5L233.8,0C161.1,43.2,108.1,97.7,84.2,125.1L84.2,125.1z\r\n\t\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol